import { useState } from "react";

//DEPENDENCIES
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

//UI COMPONENTS
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import CollapsableArrow from "../../../CollapsableArrow/CollapsableArrow";

//STYLES
import styles from "./UserSelector.module.scss";

//ASSETS
import logOutIcon from "../../../../assets/images/icons/logout-icon.svg";
import userIcon from "../../../../assets/images/icons/user-icon.svg";

//UTILS
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { logout } from "../../../../store/slices/authSlice";
import { PATH_APP } from "../../../../routes/paths";
import { getAllariaMasRedirectUrl } from "../../../../connectors/unifyApi";
import { onErrorGoToAllariaMas } from "../../../../utils";
import { openExternal } from "../../../NavBar/utils/utils";
// import {
//   openModal,
//   updateAction,
// } from "../../../../store/slices/unifiedBalanceSlice";

const UserSelector = () => {
  const { triggerContainer, menuContainer } = styles;

  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const { allariaMasLinkedAccount } = useAppSelector(
    (state) => state.authentication,
  );

  const dispatch = useAppDispatch();

  const handlegoToAllariaMas = async () => {
    try {
      const response = await getAllariaMasRedirectUrl();

      if (response.url) {
        openExternal(response.url, "_blank");
      } else {
        onErrorGoToAllariaMas();
      }
    } catch (error) {
      const errorCode =
        error && error instanceof AxiosError
          ? error?.response?.data?.code
          : null;

      onErrorGoToAllariaMas(errorCode);
    }
  };

  const dropDownOptions = [
    {
      key: "PROFILE",
      label: "Mi perfil",
      action: () => navigate(PATH_APP.profile),
    },
    ...(allariaMasLinkedAccount
      ? [
          {
            key: "ALLARIA+",
            label: (
              <div className="flex items-center space-x-2">
                <span>Ir a Allaria+</span>
                <img src={logOutIcon} alt="LogOut icon" />
              </div>
            ),
            action: () => handlegoToAllariaMas(),
          },
        ]
      : []),
    // {
    //   key: "UNIFIED_BALANCE",
    //   label: "Saldo unificado",
    //   action: () => {
    //     dispatch(openModal());
    //     dispatch(updateAction("UNIFIED_ACCOUNTS_DATA"));
    //   },
    // },
    {
      key: "LOGOUT",
      label: "Cerrar sesión",
      action: () => dispatch(logout()),
    },
  ];

  return (
    <Dropdown onOpenChange={(open) => setIsOpen(open)}>
      <DropdownTrigger>
        <div className={triggerContainer}>
          <img src={userIcon} alt="User icon" />
          <CollapsableArrow isOpen={isOpen} />
        </div>
      </DropdownTrigger>
      <DropdownMenu
        onAction={(key) => {
          const option = dropDownOptions.find((opt) => opt.key === key);
          option?.action();
        }}
        className={menuContainer}
      >
        {dropDownOptions.map((option) => (
          <DropdownItem key={option.key} textValue={option.key}>
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserSelector;
